import { type Locale } from '@sjuni/types';
import { createContext } from 'react';

/**
 * Which language the *editor fields* are showing.
 *
 * docs/05-ADMIN-DASHBOARD.md §1 is precise about this and it is easy to get
 * backwards: "the `KA|EN` toggle switches which locale the **editor fields**
 * show, not the admin chrome language (that follows `users.locale`)."
 *
 * So an editor whose own interface is Georgian can type the English translation
 * of an article without the sidebar and the buttons changing under them. The
 * two are separate settings because they answer different questions — one is
 * "what do I read", the other "what am I writing".
 *
 * Lives at the shell rather than inside `TranslatableField` so that every field
 * on a screen switches together (§4.1) and the completeness bar agrees with
 * them.
 */
export interface EditorLocaleValue {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

export const EditorLocaleContext = createContext<EditorLocaleValue | null>(null);
